export const alpacaConfig = [
	{
		id: 0,
		label: "Hair",
		directory: "hair",
		items: [
			{ id: 0, label: "Default", filename: "default"},
			{ id: 1, label: "Bang", filename: "bang"},
			{ id: 2, label: "Curls", filename: "curls"},
			{ id: 3, label: "Elegant", filename: "elegant"},
			{ id: 4, label: "Fancy", filename: "fancy"},
			{ id: 5, label: "Short", filename: "short"}
		]
	},
	{
		id: 1,
		label: "Ears",
		directory: "ears",
		items: [
			{ id: 0, label: "Default", filename: "default"},
			{ id: 1, label: "Tilt Backward", filename: "tilt-backward"},
			{ id: 2, label: "Tilt Forward", filename: "tilt-forward"}
		]
	},
	{
		id: 2,
		label: "Eyes",
		directory: "eyes",
		items: [
			{ id: 0, label: "Default", filename: "default"},
			{ id: 1, label: "Angry", filename: "angry"},
			{ id: 2, label: "Naughty", filename: "naughty"},
			{ id: 3, label: "Panda", filename: "panda"},
			{ id: 4, label: "Smart", filename: "smart"},
			{ id: 5, label: "Star", filename: "star"}
		]
	},
	{
		id: 3,
		label: "Mouth",
		directory: "mouth",
		items: [
			{ id: 0, label: "Default", filename: "default"},
			{ id: 1, label: "Astonished", filename: "astonished"},
			{ id: 2, label: "Eating", filename: "eating"},
			{ id: 3, label: "Laugh", filename: "laugh"},
			{ id: 4, label: "Tongue", filename: "tongue"},
		]
	},
	{
		id: 4,
		label: "Neck",
		directory: "neck",
		items: [
			{ id: 0, label: "Default", filename: "default"},
			{ id: 1, label: "Bend Backward", filename: "bend-backward"},
			{ id: 2, label: "Bend Forward", filename: "bend-forward"},
			{ id: 3, label: "Thick", filename: "thick"},
		]
	},
	{
		id: 5,
		label: "Leg",
		directory: "leg",
		items: [
			{ id: 0, label: "Default", filename: "default"},
			{ id: 1, label: "Bubble Tea", filename: "bubble-tea"},
			{ id: 2, label: "Cookie", filename: "cookie"},
			{ id: 3, label: "Game Console", filename: "game-console"},
			{ id: 4, label: "Tile Backward", filename: "tilt-backward"},
			{ id: 5, label: "Tilt Forward", filename: "tilt-forward"}
		]
	},
	{
		id: 6,
		label: "Nose",
		directory: "nose",
		items: [
			{ id: 0, label: "Default", filename: "default"}
		]
	},
	{
		id: 7,
		label: "Accessories",
		directory: "accessories",
		items: [
			{ id: 0, label: "Default", filename: "default"},
			{ id: 1, label: "Earings", filename: "earings"},
			{ id: 2, label: "Flower", filename: "flower"},
			{ id: 3, label: "Glasses", filename: "glasses"}
		]
	},
	{
		id: 8,
		label: "Backgrounds",
		directory: "backgrounds",
		items: [
			{ id: 0, label: "Darkblue 30", filename: "darkblue70"},
			{ id: 1, label: "Blue 50", filename: "blue50"},
			{ id: 2, label: "Blue 60", filename: "blue60"},
			{ id: 3, label: "Blue 70", filename: "blue70"},
			{ id: 4, label: "Green 60", filename: "green60"},
			{ id: 5, label: "Green 70", filename: "green70"},
			{ id: 6, label: "Grey 40", filename: "grey40"},
			{ id: 7, label: "Grey 70", filename: "grey70"},
			{ id: 8, label: "Grey 80", filename: "grey80"},
			{ id: 9, label: "Red 50", filename: "red50"},
			{ id: 10, label: "Red 60", filename: "red60"},
			{ id: 11, label: "Red 70", filename: "red70"},
			{ id: 12, label: "Yellow 50", filename: "yellow50"},
			{ id: 13, label: "Yellow 60", filename: "yellow60"},
			{ id: 14, label: "Yellow 70", filename: "yellow70"}
		]
	}
];